import type { SuggestedChip } from "@/lib/api/chat";

const HIDDEN_SUGGESTION_LABEL = /\bshow me\b/i;

export function isVisibleSuggestedChip(chip: SuggestedChip): boolean {
  return !HIDDEN_SUGGESTION_LABEL.test(chip.label);
}

export function filterVisibleSuggestedChips(chips: SuggestedChip[]): SuggestedChip[] {
  return chips.filter(isVisibleSuggestedChip);
}
